var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { FieldName } from './types';
var FIELDS_TO_PARAMS = (_a = {},
    _a[FieldName.CAMPAIGN_ID] = 'ci',
    _a[FieldName.CLIENT_ID] = 'cid',
    _a[FieldName.DATA] = 'data',
    _a[FieldName.EVENT_ACTION] = 'ea',
    _a[FieldName.EVENT_CATEGORY] = 'ec',
    _a[FieldName.EVENT_LABEL] = 'el',
    _a[FieldName.EVENT_VALUE] = 'ev',
    _a[FieldName.INVITER_ID] = 'iuuid',
    _a[FieldName.LANGUAGE] = 'ul',
    _a[FieldName.LOCATION] = 'dl',
    _a[FieldName.PAGE] = 'dp',
    _a[FieldName.PORTAL_TIME] = 'pt',
    _a[FieldName.SCREEN_RESOLUTION] = 'sr',
    _a[FieldName.SEQ] = '_seq',
    _a[FieldName.SESSION_ID] = 'sid',
    _a[FieldName.TIMESTAMP] = '_t',
    _a[FieldName.TITLE] = 'dt',
    _a[FieldName.TOPIC] = '__topic__',
    _a[FieldName.TYPE] = 't',
    _a[FieldName.USER_ID] = 'uid',
    _a[FieldName.USER_UUID] = 'uuid',
    _a[FieldName.VIEWPORT_SIZE] = 'vp',
    _a);
export default function fieldsToParams(fieldsObject) {
    return Object.keys(fieldsObject)
        .filter(function (fieldName) { return fieldName in FIELDS_TO_PARAMS && fieldsObject[fieldName] !== undefined; })
        .reduce(function (obj, fieldName) {
        var _a;
        var fieldValue = fieldsObject[fieldName];
        if (Object.prototype.toString.call(fieldValue) === '[object Object]') {
            fieldValue = JSON.stringify(fieldValue);
        }
        return __assign(__assign({}, obj), (_a = {}, _a[FIELDS_TO_PARAMS[fieldName]] = fieldValue, _a));
    }, {});
}
//# sourceMappingURL=fields-to-params.js.map


//////////////////
// WEBPACK FOOTER
// ../tracker/build/src/fields-to-params.js
// module id = 1117
// module chunks = 0